import React, { useState } from 'react';
import GridSearchTemplate from '../../../pages/GridSearchTemplate';
import { useTextResources } from '../../../language';
import CustomerDropDown from "../../shared/CustomerDropDown";
import HotelsDropDown from "../../shared/HotelsDropDown";
import { DatePicker } from '../../../components/shared/DatePicker'
import TagsDropDown from '../../shared/TagsDropDown';
import { Icon, Form, Label, Popup } from 'semantic-ui-react';
import { Folio, Invoice } from '../../../api/services/next';
import { dateFormat, SystemTagsEnum, ReservationStatuses } from '../../shared/constants';
import InvoiceStatusDropDown from '../../shared/InvoiceStatusDropDown';
import { InvoiceStatuses, InvoiceStatusesEnum } from '../../shared/constants';

// Invoice Status mapping
const InvoiceStatusColors = {
    [InvoiceStatusesEnum.Open]: 'red',
    [InvoiceStatusesEnum.Pending]: 'orange',
    [InvoiceStatusesEnum.Closed]: 'green',
    [InvoiceStatusesEnum.TechnicalErrors]: 'yellow'
};
import moment from 'moment'
import { endpoint } from '../../../api/http';
import { onWarning, onError, onSuccess } from '../../shared/messages'
import { RenderTemplateWithReCalcTax, GetFoliosForChainHotels } from '../../../api/services/finance'
import { useLoader } from '../../shared/utils'
import saveAs from 'file-saver'
import { IconButton } from '../../shared/icons'


const PendingFoliosReport = () => {
    const text = useTextResources()
    const loader = useLoader();
    const [spec, setSpec] = useState()
    const [data, setData] = useState([])

    const getTaxAuthorityApproval = async (row) => {
        loader(true)
        try {
            const error = await Invoice.GetTaxAuthorityApproval({
                Invoice_ID: row.InvoiceId.toString(),
                Customer_VAT_Number: row.CustomerVatNumber,
                Customer_Name: row.Name
            })
            if (error != "200") {
                loader(false)
                onWarning(error)
                return;
            }
            else {
                try {
                    await createInvoiceTemplate(row.InvoiceId)
                    await refreshData()
                    onSuccess()
                }
                catch (error) {
                    onError(error)
                }
                finally {
                    loader(false)
                }
            }
        }
        catch (error) {
            onError(error)
        }
        finally {
            loader(false)
        }
    }

    const issueInvoiceWithoutApproval = async (invoiceId, folioId) => {
        loader(true)
        try {
            const invoice = await Invoice.GetInvoice({ Id: invoiceId, IncludeTaxAuthorityInvoiceError: true })

            await Invoice.PostInvoice(invoice)
            await Invoice.RemoveTaxAuthorityPendingTag(folioId)
            await createInvoiceTemplate(invoiceId, invoice)
            const taxAuthorityError = invoice?.TaxAuthorityInvoiceErrors?.find(error => error.Id === invoice.TaxAuthorityInvoiceErrorId)
            if (taxAuthorityError) {
                taxAuthorityError.InvoiceStatus = 3 //Closed = 3,
                await Invoice.PostTaxAuthorityError(taxAuthorityError)
            }
            await refreshData()
            onSuccess()
        }
        catch (error) {
            onError(error)
        }
        finally {
            loader(false)
        }
    }

    const refreshData = async () => {
        var data = await Folio.GetPendingFoliosReport(spec)
        onSearchComplete(data)
    }
    const createInvoiceTemplate = async (invoiceId, invoice = null) => {
        try {

            if (invoice === null) {
                invoice = await Invoice.GetInvoice({ Id: invoiceId })
            }

            const files = []

            const paramters = [
                { key: "CurrencyId", value: invoice.CurrencyId.toString() },
                { key: "FolioId", value: invoice.FolioId.toString() },
                    { key: "InvoiceId", value: invoiceId.toString() }]

            const copy = await RenderTemplateWithReCalcTax({
                IsPrintable: true,
                TemplateID: invoice.TemplateId,
                HotelID: invoice.HotelId,
                Paramters: [
                    ...paramters,
                    { key: "InvoiceTitle", value: "CopyTaxInvoice" }
                ]
            })

            files.push(copy.PdfDto.DmzUrlPathAccessibleByBrowser)

            const original = await RenderTemplateWithReCalcTax({
                IsPrintable: true,
                TemplateID: invoice.TemplateId,
                HotelID: invoice.HotelId,
                Paramters: [
                    ...paramters,
                    { key: "InvoiceTitle", value: "OriginalTaxInvoice" }
                ]
            })
            files.push(original.PdfDto.DmzUrlPathAccessibleByBrowser)

            files.forEach(file => {
                saveAs(file)
            })
        }
        catch (error) {
            onError(error)
        }
    }
    const onSearchComplete = async (data) => {
        loader(true)
        try {
            if (data?.length > 0) {
                const updatedData = data
                const folioIds = data.map(s => s.FolioId);
                const hotelIds = data.map(s => s.HotelId);
                const totals = await GetFoliosForChainHotels({
                    IDs: folioIds,
                    HotelIDs: hotelIds,
                    Currency: window.user?.CurrentHotel?.MainCurrencyId,
                    IncludeFolioTransactionTaxDetails: true,
                    IncludeTaxFolioTransactions: true,
                });

                if (totals && totals.length) {
                    updatedData.forEach(res => {
                        if (!res.InvoiceId) {
                            const resTotals = totals.find(s => s.Id == res.FolioId)
                            res.OpenBalance = resTotals && (resTotals.RestPayment)
                        }
                    });
                }
                setData(updatedData)
            }
            else{
                setData([])
        }
        }
        catch (error) {
            onError(error)
        }
        finally {
            loader(false)

        }
    }
    const approvalFormatter = ({ row }) => {
        return row.PendingId.filter(c => c == SystemTagsEnum.TaxAuthorityPending).length > 0 &&
               row.InvoiceStatus != InvoiceStatusesEnum.Open  ?
            <div style={{ display: 'flex', gap: '5px' }}>
                <IconButton
                    onClick={() => getTaxAuthorityApproval(row)}
                    content={"IssueWithAllocation"}
                >
                    <Icon name='caret square down outline' />
                </IconButton>
                <IconButton
                    onClick={() => issueInvoiceWithoutApproval(row.InvoiceId, row.FolioId)}
                    content={"IssueWithoutAllocation"}
                >
                    <Icon name='caret square down' />
                </IconButton>
            </div>
            : ''
    }

    const tagsFormatter = ({ value }) => {
        return value.map(val => {
            return <div key={"j"}>
                <Label
                    style={{ marginBottom: 2 }}
                    key={val}>
                    {val}
                </Label>
                <br />
            </div>
        })
    }
    const dateFormatter = ({ value }) => {
        return value ? moment(value).format(dateFormat) : ''
    }
    const folioFormatter = ({ value, row }) => {
        return <a target="_blank" rel="noopener noreferrer" href={`${endpoint}Finance/Folio/Folio?FolioId=${row?.FolioId}`}>{value}</a>
    }
    const guestFormatter = ({ value, row }) => {
        return <a target="_blank" rel="noopener noreferrer" href={`${endpoint}CRM/GuestProfile/index/#/profile/${row?.GuestId}?hotelid=${row?.HotelId}`}>{value}</a>
    }
    const customerFormatter = ({ value, row }) => {
        return <a target="_blank" rel="noopener noreferrer" href={`${endpoint}CRM/Customers/Edit/${row?.CustomerId}`}>{value}</a>
    }
    const errorMessageFormatter = ({ value }) => {
        let errorMessage
        if (value) {
            const errorData = JSON.parse(value ?? 0);
            errorMessage = errorData.map(error => error.message + ', \n')
        }
        return errorMessage ? <Popup trigger={<div>{errorMessage}</div>}
            content={errorMessage} />
            : ''
    }
    const reservationStatussFormatter = ({ value }) => {
        return value ? ReservationStatuses[value] : ''
    }
    const currencyFormat = (value) => {
        return `${value.toFixed(2)}`
    }
    const currencyFormatter = ({ value }) => {
        if (value)
            return value && currencyFormat(value)
        else
            return 0
    }
    const onSearchChange = (spec) => {
        setSpec(spec)
    }

    // Invoice status formatter with colored labels
    const invoiceStatusFormatter = ({ value, row }) => {
        if (!value) return '';
        const color = InvoiceStatusColors[value] || 'grey';
        return (
            <Label color={color} size="tiny">
                {InvoiceStatuses[row.InvoiceStatus] || ''}
            </Label>
        );
    }
    const gridOptions = {
        search: {
            title: text("PendingFoliosReport"),
            initial: {
                InvoiceStatus: [InvoiceStatusesEnum.Open, InvoiceStatusesEnum.Pending, InvoiceStatusesEnum.TechnicalErrors]  // All invoice statuses selected by default (excluding Closed)
            },
            fields: [
                <Form.Field
                    placeholder={text("All")}
                    multiple
                    clearable
                    control={HotelsDropDown}
                    label="Hotel"
                    key="HotelIds" />,
                <Form.Field
                    label={text("Pending")}
                    placeholder={text("All")}
                    control={TagsDropDown}
                    IsSystem={true}
                    multiple
                    clearable
                    key="TagIds" />,
                <Form.Field
                    label={text("Customers")}
                    placeholder={text("All")}
                    control={CustomerDropDown}
                    multiple
                    clearable
                    key="CustomerIds" />,
                <Form.Field
                    label={text("InvoiceStatus")}
                    placeholder={text("All")}
                    control={InvoiceStatusDropDown}
                    multiple
                    selection
                    clearable
                    key="InvoiceStatus" />,
                <DatePicker
                    type='range'
                    label={text('ArrivalDate')}
                    key={'CheckInDateRange'}
                />,
                <DatePicker
                    type='range'
                    label={text('DepartureDate')}
                    key={'CheckOutDateRange'}
                />,
                <DatePicker
                    type="basic"
                    label={text("PendingDate")}
                    name="PendingDate"
                    key="PendingDate"
                />,
            ],
            api: Folio.GetPendingFoliosReport,
            spec: {
                MaxResults: 2000
            },
        },
        grid: {
            columns: [
                { name: 'FolioNumber', title: text("Folio"), formatter: folioFormatter },
                { name: 'GuestName', title: text("GuestName"), formatter: guestFormatter },
                { name: 'CustomerName', title: text("Customer"), formatter: customerFormatter },
                { name: 'GroupName', title: text("GroupName") },
                { name: 'PendingType', title: text("Pending"), formatter: tagsFormatter },
                { name: 'OpenBalance', title: text("OpenBalance"), formatter: currencyFormatter },
                { name: 'ArrivalDate', title: text("ArrivalDate"), formatter: dateFormatter },
                { name: 'DepartureDate', title: text("DepartureDate"), formatter: dateFormatter },
                { name: 'ResStatus', title: text("ReservationStatus"), formatter: reservationStatussFormatter },
                { name: 'InvoiceStatus', title: text("InvoiceStatus"), formatter: invoiceStatusFormatter },
                { name: 'ApprovalErrorMessage', title: text("ErrorMessage"), formatter: errorMessageFormatter },
                { name: 'InvoiceNumber', title: text("InvoiceNumber") },
                { name: '', formatter: approvalFormatter }
            ],
            export: true,
            paging: true,
        }
    }
    return (<GridSearchTemplate
        options={gridOptions}
        onSearchChange={onSearchChange}
        onSearchComplete={onSearchComplete}
        data={data} />)
}
export default PendingFoliosReport